  <template>
    <!-- 経費 -->
    <div>
      <CCard>
        <CCardHeader>
          <h2>経費精算(仮払申請)</h2>
        </CCardHeader>
        <CCardBody>
          <table class="table search-table">
            <tr>
              <th style="width: 100px">年月</th>
              <th style="width: 75px"></th>
              <th style="width: 50px"></th>
              <th></th>
            </tr>
            <tr>
              <td>
                <select
                  class="custom-select preika-control--year"
                  v-model="year"
                 
                >
                  <option
                    v-for="option in yearOption"
                    :value="option.id"
                    :key="option.id"
                  >
                    {{ option.name }}
                  </option>
                </select>
              </td>
              <td>
                <select
                  class="custom-select preika-control--month"
                  v-model="month"
                 
                >
                  <option
                    v-for="option in monthOption"
                    :value="option.id"
                    :key="option.id"
                  >
                    {{ option.name }}
                  </option>
                </select>
              </td>
              <td>業務分</td>
              <td>
                <button class="btn btn-primary" @click="callList">表示</button>
              </td>
            </tr>
          </table>
          <br />※普段の通勤に使う交通費は「通勤費精算」にて申請して下さい。
        </CCardBody>
        <template v-if="displayFlg">
          <CCardHeader>
            <tr><td>
              <strong
                v-if="showYearMonth"
                style="font-size: 20px; font-weight: bold"
              >
                {{ selectYear }} 年 {{ selectMonth }} 月
                <span style="margin-left: 10px"></span>
                <span :style="statusColor(status)">【{{ getStatusLabel(status) }}】</span>
              </strong>
            </td></tr>
            <tr><td v-if="errors.length">
              <div class="preika-form-message" v-for="error in errors" :key="error">
                {{ error }}
              </div>
            </td></tr>
          </CCardHeader>
          <CCardHeader>
            <strong>経費</strong>
          </CCardHeader>
          <CCardBody>
            <ExpenseError
              ref="error"
              :day1="day1"
              :request_type="request_type"
              :origin="origin"
              :destination="destination"
              :route="route"
              :cost="cost"
              :remarks="remarks"
              :temporary="temporary"
              :project_id="project_id"
              :project_list="projectList"
              :rows="num1"
            ></ExpenseError>
            <!--
              「* が付いている項目は…」の凡例は ExpenseError が出す。
              **画面ごとに書くと、通勤費と経費で位置がずれる。**
              ここに残すのは経費だけにある補足。
            -->
            <p class="preika-form-hint">※1:出張交通費のみ「出発」「到着」は必須項目です</p>
            <CRow>
              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th width="100px" nowrap>
                        <div>年月日<span class="asterisk">*</span></div>
                        <div>申請区分<span class="asterisk">*</span></div>
                        <!--
                          プロジェクト名は保存の条件に入っている。印が無いと、
                          既定が入らない利用者（所属プロジェクトが取れない人）は
                          **埋めるべき欄が分からないまま保存できない。**
                        -->
                        <div>プロジェクト名<span class="asterisk">*</span></div>
                      </th>
                      <th width="100px" nowrap>
                        <div>金額<span class="asterisk">*</span></div>
                        <div>仮払(事前受取額)</div>
                      </th>
                      <th width="100px" nowrap>
                        <div>交通機関・施設<span class="asterisk">*</span></div>
                        <div>内訳(備考)<span class="asterisk">*</span></div>
                      </th>
                      <th width="100px" nowrap>
                        <div>出発<span class="asterisk">*</span>※1</div>
                        <div>到着<span class="asterisk">*</span>※1</div>
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(n, index) in lists1" :key="index">
                      <td>
                        {{ selectYear }}年{{ selectMonth }}月
                        <select
                          class="custom-select preika-control--day"
                          v-model="day1[index]"
                          @blur="day1_check"
                          style="margin-top: 10px; margin-bottom: 15px"
                        >
                          <option v-for="option in days" :key="option">
                            {{ option }}
                          </option>
                        </select>
                        日<br>
                        <select
                          class="custom-select preika-control--detail"
                          v-model="request_type[index]"
                          @blur="type_check"
                          style="margin-bottom: 10px"
                        >
                          <option
                            v-for="option in options"
                            :value="option.id"
                            :key="option.id"
                          >
                            {{ option.name }}
                          </option>
                        </select>
                        <br/>
                        <select
                          class="custom-select preika-control--reference"
                          v-model="project_id[index]"
                          @change="syncProjectName(index)"
                          style="margin-bottom: 10px"
                        >
                          <option v-for="p in projectList" :key="p.id" :value="p.id">
                            {{ p.name }}<template v-if="p.external">（現在所属外）</template>
                          </option>
                        </select>
                      </td>
                      <td>
                        <CInput
                          v-model="cost[index]"
                          @beforeinput.native="digitsOnly('cost', index, $event)"
                          @input.native="sanitizeDigits('cost', index)"
                          @focus="deleteCost"
                          @blur="addCost"
                          inputmode="numeric"
                          pattern="[0-9]*"
                          style="width: 100px; margin-bottom: 0px;"
                          placeholder="金額"
                        />
                        <br/>
                        <CInput
                          v-model="temporary[index]"
                          @beforeinput.native="digitsOnly('temporary', index, $event)"
                          @input.native="sanitizeDigits('temporary', index)"
                          @focus="deleteTemporary"
                          @blur="addTemporary"
                          inputmode="numeric"
                          pattern="[0-9]*"
                          style="width: 100px; margin-top: 0px; margin-bottom: 0px;"
                          placeholder="仮払金額"
                        />
                      </td>
                      <td>
                        <CInput
                          v-model="route[index]"
                          @blur="route_check"
                          style="width: 300px;margin-bottom: 0px;"
                          placeholder="交通機関・施設など"
                        />
                        <br/>
                        <CInput
                          v-model="remarks[index]"
                          @blur="remarks_check"
                          style="width: 300px;margin-bottom: 0px;"
                          placeholder="内訳(備考) 使用用途など"
                        />
                      </td>
                      <td>
                        <CInput
                          v-model="origin[index]"
                          @blur="origin_check"
                          style="width: 300px;margin-top: 10px;margin-bottom: 0px;"
                          placeholder="出発"
                        /><br/>
                        <CInput
                          v-model="destination[index]"
                          @blur="destination_check"
                          style="width: 300px;margin-bottom: 10px;"
                          placeholder="到着"
                        />
                      </td>
                      <td>
                      <button
                        v-if="index > 0"
                        class="btn btn-info"
                        :disabled="statusBtn"
                        @click="copyFromPrev(index)"
                        style="margin-top: 17px; margin-bottom: 5px; width: 80px"
                      >
                        コピー
                      </button>
                      <br v-if="index > 0" />
                        <button
                          class="btn btn-danger deleteBtn"
                          :disabled="statusBtn"
                          @click="deleteCheck1(index)"
                          style="margin-top: 17px; width: 80px"
                        >
                          削除
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </CRow>
            <CRow>
              <CCol sm="1">
                <button
                  @click="addForm1"
                  class="btn btn-primary btn-add"
                  :disabled="!activeAddButton || statusBtn"
                >
                  追加
                </button>
              </CCol>
            </CRow>
            <br />
            <CRow>
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th class="title"><label>交通費小計</label></th>
                    <th class="title"><label>経費小計</label></th>
                    <th class="title"><label>宿泊費小計</label></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <span>{{ totalTransport }}</span>
                    </td>
                    <td>
                      <span>{{ totalExpense }}</span>
                    </td>
                    <td>
                      <span>{{ totalStay }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </CRow>
          </CCardBody>
          <CCardHeader>
            <strong>合計支払額</strong>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th class="title"><label>経費合計</label></th>
                    <th class="title"><label>仮払小計</label></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <span>{{ totalCost }}</span>
                    </td>
                    <td>
                      <span>{{ totalTemporary }}</span>
                    </td>
                  </tr>
                </tbody>
                <thead>
                  <tr>
                    <th class="title" colspan="2"><label>差引戻・払額</label></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colspan="2">
                      <span>{{ sumPayment }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </CRow>
            <!--
              押せない理由を、表の上だけでなく［保存］のすぐ上にも出す（［保存］は行・小計・
              合計の表の下にあり、上の理由は見えなかった）。承認待ち・承認済みは上と同じ文、
              入力が足りないときは、表の上の一覧を見てもらう。
            -->
            <ActionResultMessage :text="saveBlockedReason" type="info" :reveal="false" />
            <CRow>
              <CCol class="text-center">
                <save-button
                  :label="'保存'"
                  :loading="loading"
                  class="btn btn-primary btn-register"
                  @click="edit"
                  :disabled="activeButton || statusBtn"
                />
              </CCol>
            </CRow>
            <p class="text-center text-muted my-2">
            ※保存後、「自分の申請一覧」画面から、他の書類とまとめて承認申請を行ってください。
            </p>
          </CCardBody>
        </template>
      </CCard>
    </div>
  </template>

  <script>
  import axios from "axios";
  import moment from "moment";
  import ConstList from "./../../ConstList";
  import { requestFailureMessage } from '@/utils/requestFailure';
import { backendErrorMessage } from '../../utils/rosterActualPolicy';

  // 上限は本番の t_expense の列定義と同じ値。ExpenseError.vue の表示、
  // サーバの ExpenseFieldLengthGuard と3つそろえる。どれか1つだけ変えると、
  // 画面では通ってサーバで落ちる、という食い違いに戻る。
  const MAX_LENGTH = {
    origin: 128,
    destination: 128,
    route: 128,
    remarks: 100,
  };
  import SubmissionConst from "./../../submission_approval/ConstList";
  import ExpenseError from "./ExpenseError";
  import SaveButton from '../../common/SaveButton';
  import ActionResultMessage from '../../components/ActionResultMessage.vue';
  import { submissionLockReason } from '../../utils/submissionLockReason';
  import { askedYearMonth } from '../../utils/askedYearMonth';

  export default {
    name: "Expense",
    components: {
      ExpenseError,
      SaveButton,
      ActionResultMessage,
    },
    data() {
      return {
        num1: 0,
        id: [],
        year: "",
        month: "",
        name: "",
        days: [],
        project: "",
        projectList: [],
        project_name: [],
        project_id: [],
        day1: [],
        request_type: [],
        options: [
          {
            id: ConstList.TRANSPORT_ID,
            name: ConstList.TRANSPORT,
          },
          {
            id: ConstList.EXPENSE_ID,
            name: ConstList.EXPENSE,
          },
          {
            id: ConstList.STAY_ID,
            name: ConstList.STAY,
          },
        ],
        payment: [
          {
            id: ConstList.DEFERRED_PAYMENT_ID,
            name: ConstList.DEFERRED_PAYMENT,
          },
          {
            id: ConstList.ADVANCE_PAYMENT_ID,
            name: ConstList.ADVANCE_PAYMENT,
          },
        ],
        payment_flag: false,
        origin: [],
        destination: [],
        route: [],
        cost: [],
        remarks: [],
        temporary: [],
        sum_transport: [],
        sum_expense: [],
        sum_stay: [],
        sum_cost: [],
        sum_temporary: [],
        total: [],
        status: "",
        errors: [],
        // 二重サブミット対処フラグ
        editSubmit: false,
        activeAddButton: false,
        showYearMonth: false,
        submit_flg:  false,
        // 状態によるボタン非活性化
        statusBtn: false,
        displayFlg: false,
        loading: false,
      };
    },
    created() {
      this.yearOption = ConstList.YEAR_OPTION;
      this.monthOption = ConstList.MONTH_OPTION;
    },

    methods: {
      // DBから一覧呼出メソッド
      callList: function () {
        this.num1 = 0;
        this.project_name = [];
        this.day1 = [];
        this.request_type = [];
        this.origin = [];
        this.destination = [];
        this.route = [];
        this.cost = [];
        this.remarks = [];
        this.days = [];
        this.temporary = [];
        this.displayFlg = false;
        this.activeAddButton = true;
        /*
         * **見出しの月は、頼んだ月。**応答が返った時点の選択欄から入れていたので、
         * 待つあいだに選択欄を変えると、前の月の行に次の月の見出しが付き、
         * ［保存］がその見出しの月の明細を消して入れ直していた。
         */
        const year = this.year;
        const month = this.month;
        const params = new URLSearchParams();
        params.append("year", year);
        params.append("month", month);
        axios
          .get(process.env.VUE_APP_API_ORIGIN + "/expenseSelect", {
            params: {
              year: year,
              month: month,
            },
          })
          .then((response) => {
            this.showYearMonth = true;
            this.selectYear = year;
            this.selectMonth = month;
            this.num1 = 0;
            this.id = [];
            this.project_id = [];
            this.project_name = [];
            this.day1 = [];
            this.request_type = [];
            this.origin = [];
            this.destination = [];
            this.route = [];
            this.cost = [];
            this.remarks = [];
            this.days = [];
            this.temporary = [];
            this.status = "";
            this.errors = [];
            (this.displayFlg = true), (this.statusBtn = false);
            const start = moment(year + "-" + month + "-01").startOf(
              "month"
            );
            const end = moment(year + "-0" + month + "-01").endOf(
              "month"
            );
            while (start.unix() <= end.unix()) {
              this.days.push(start.format("D"));
              start.add(1, "days");
            }
            response.data.forEach((element) => {
              try {
                this.num1++;
                this.id.push(element.id);
                this.project_id.push(element.project_id);
                this.project_name.push(element.project_name);
                this.day1.push(element.date.substring(8).replace(/^0+/, ""));
                this.request_type.push(element.request_type);
                this.origin.push(element.origin);
                this.destination.push(element.destination);
                this.route.push(element.route);
                // 金額・仮払が入っていない明細（本番は空を許す）は空欄にする。
                // 「null」の文字を入れていたので、合計が ￥NaN になっていた。
                this.cost.push(element.cost == null ? "" : element.cost + "");
                this.temporary.push(element.temporary == null ? "" : element.temporary + "");
                this.remarks.push(element.remarks);
                this.status = element.status;
              } catch (error) {
                if (!element.project_name) {
                  alert("プロジェクト管理にて、プロジェクトを設定して下さい。");
                  this.$router.push({
                    name: ConstList.ROUTE_PROJECT_LIST,
                  });
                }
              }
            });
            /*
             * **状態の値は ConstList から取る。**
             *
             * SubmissionConst にはメッセージしか入っていない。
             * SubmissionConst.APPROVAL_PENDING / .APPROVAL は undefined で、
             * **この判定は一度も成立していなかった。**
             * 承認済みでも保存ボタンが押せたまま残り、実機で
             * 承認済みの経費を書き換えられた（承認済みだった提出物の行が
             * 消えて未申請へ作り直された）。
             *
             * 通勤費（TravelCost.vue）は同じ場面で ConstList を見ていて
             * 正しく止まっていた。**同じ作りの2画面で、片方だけ壊れていた。**
             */
            // 承認待ち状態はメッセージ表示とボタン非活性化
            if (this.status == ConstList.APPROVAL_PENDING) {
              this.errors.push(SubmissionConst.ERROR_UPDATE_MESSAGE_PENDING);
              this.statusBtn = true;
            }
            // 承認済み状態はメッセージ表示とボタン非活性化
            else if (this.status == ConstList.APPROVAL) {
              this.errors.push(SubmissionConst.ERROR_UPDATE_MESSAGE_APPROVAL);
              this.statusBtn = true;
            }
            // === ここから追記：勤務表と同じ集合ロジック ===
            return axios
              // ※通常ユーザーはセッションから判定される想定。必要なら userId を params に付与
              .get(process.env.VUE_APP_API_ORIGIN + "/projects");
            })
            .then(({ data: belong }) => {
              const belongArr = (belong || []).map(p => ({ id: +p.id, name: p.name }));
              const belongIdSet = new Set(belongArr.map(p => p.id));

              // 経費の当月データに出てくる保存済みプロジェクトを抽出
              const fromItems = (this.project_id || [])
                .map((id, i) =>
                  (id !== null && id !== undefined && !isNaN(+id))
                    ? { id: +id, name: this.project_name?.[i] || `(ID:${+id})` }
                    : null
                )
                .filter(Boolean);

              // 所属＋履歴をIDでユニーク化、所属外には external を付与
              const map = new Map();
              [...belongArr, ...fromItems].forEach(p => {
                if (!map.has(p.id)) {
                  map.set(p.id, { id: p.id, name: p.name, external: !belongIdSet.has(p.id) });
                }
            });
            this.projectList = Array.from(map.values());
            // 未選択なら先頭を既定でセット
            if (this.projectList.length) {
              for (let i = 0; i < this.num1; i++) {
                if (!this.project_id[i]) {
                  this.$set(this.project_id, i, this.projectList[0].id);
                  this.$set(this.project_name, i, this.projectList[0].name);
                }
              }
            }
            // 読み込んだ行に空の必須列があっても、利用者がその欄を
            // 触るまで何も出ない。開いた時点で理由を出しておく。
            this.recheck();
            })
          .catch((error) => {
            this.displayFlg = false;
            axios
            .post(`${process.env.VUE_APP_API_ORIGIN}/error/frontError`, { error: String(error) }, { headers: { 'Content-Type': 'application/json' } })
            .then(() => {
              alert(requestFailureMessage(error));
            })
            .catch(() => {
              alert(requestFailureMessage(error, ConstList.SYSTEM_COMMUNICATION_ERROR));
            });
          });
      },

      // 金額3桁ごとにカンマを付けるメソッド
      addComma: function (value) {
        const list = value;
        for (let i = 0; i < list.length; i++) {
          const comma = list[i]
            .toString()
            .replace(/([0-9]+?)(?=(?:[0-9]{3})+$)/g, "$1,");
          list.splice(i, 1, comma);
          if (!comma) {
            list.splice(i, 1, "");
          }
        }
      },
      // カンマ付加と金額のエラーチェックメソッド(経費)
      addCost: function () {
        this.$refs.error.cost_empty();
        this.addComma((this.cost));
        this.$refs.error.cost_regex();
      },
      // カンマ付加メソッド(仮払)
      addTemporary: function () {
        this.addComma((this.temporary));
        this.$refs.error.temporary_regex();
      },
      // フォーカスが当たるとカンマを外すメソッド
      deleteComma: function (value) {
        const list = value;
        for (let i = 0; i < list.length; i++) {
          const comma = list[i].replace(/,/g, "");
          list.splice(i, 1, comma);
          if (!comma) {
            list.splice(i, 1, "");
          }
        }
      },
      // カンマ除去メソッド(経費)
      deleteCost: function () {
        this.deleteComma((this.cost));
      },
      // カンマ除去メソッド(仮払)
      deleteTemporary: function () {
        this.deleteComma((this.temporary));
      },
      // 入力欄の追加(経費)
      addForm1: function () {
        // 二重サブミット対策
        if (this.submit_flg) return;
        this.num1++;
        // 一行目のプロジェクト名を行追加ごとに表示させる
        const baseId = this.project_id.length ? this.project_id[0] : (this.projectList[0]?.id ?? null);
        const baseName = (this.projectList.find(x => x.id === baseId)?.name) || this.project_name[0] || '';
        this.project_id.push(baseId);
        this.project_name.push(baseName);
        this.recheck();
      },
      // 選択項目の削除メソッド(経費)
      deleteCheck1(index) {
        // 二重サブミット対策
        if (this.editSubmit) return;
        // 画面上のデータを削除
        if (
          this.day1[index] ||
          this.request_type[index] ||
          this.origin[index] ||
          this.destination[index] ||
          this.route[index] ||
          this.cost[index] ||
          this.remarks[index]
        ) {
          if (
            confirm(
              "データが入力されていますが、経費の" +
                (index + 1) +
                "行目を削除してもよろしいですか？"
            )
          );
          else {
            // キャンセルした場合
            return;
          }
        }
          //成功時の行の削除
        this.id.splice(index, 1);
        this.project_id.splice(index, 1); 
        this.day1.splice(index, 1);
        this.request_type.splice(index, 1);
        this.origin.splice(index, 1);
        this.destination.splice(index, 1);
        this.route.splice(index, 1);
        this.temporary.splice(index, 1);
        this.cost.splice(index, 1);
        this.remarks.splice(index, 1);
        this.num1--;
        this.recheck();
      },
      // 金額の欄を数にする。空・未入力（［追加］したばかりの行など）は0円として数える。
      // 経費合計・仮払小計と同じ数え方。区分ごとの小計だけ空を見ていなかったので、
      // 金額を消すと ￥NaN、未入力の行があると描き直しごと止まっていた。
      amountValue: function (value) {
        if (value === null || value === undefined) return 0;
        const number = parseInt(String(value).replace(/,/g, ""), 10);
        return isNaN(number) ? 0 : number;
      },
      // 上限を超えているか。未入力は超えていない扱い。
      overMaxLength: function (value, max) {
        return typeof value === "string" && value.length > max;
      },
      // 日付（経費）のエラーチェック
      day1_check: function () {
        this.$refs.error.day1_empty();
      },
      // 申請区分のエラーチェック
      type_check: function () {
        this.$refs.error.type_empty();
      },
      //仮払有り無しのエラーチェック
      payment_check: function () {
        this.$refs.error.payment_empty();
      },
      // 発地のエラーチェック
      origin_check: function () {
        this.$refs.error.origin_empty();
        this.$refs.error.origin_max();
      },
      // 着地のエラーチェック
      destination_check: function () {
        this.$refs.error.destination_empty();
        this.$refs.error.destination_max();
      },
      // 交通機関・施設のエラーチェック
      route_check: function () {
        this.$refs.error.route_empty();
        this.$refs.error.route_max();
      },
      // 行ぜんぶを見直す。
      //
      // 各チェックは「その欄から離れたとき」しか走らない。**一度も触って
      // いない欄は空のまま何も言わず、保存ボタンだけが無効になる。**
      // 「追加」で作った直後の行がまさにそれで、押せない理由が1つも
      // 出ていなかった。行が増減したときと読み込み直後に呼ぶ。
      //
      // 子へ渡す行数(rows)は描画のあとに届くので nextTick で待つ。
      // 待たずに呼ぶと、増えたはずの行が1つ足りないまま数えられる。
      recheck: function () {
        this.$nextTick(() => {
          if (!this.$refs.error) return;
          this.day1_check();
          this.type_check();
          this.origin_check();
          this.destination_check();
          this.route_check();
          this.remarks_check();
          this.$refs.error.cost_empty();
          this.$refs.error.cost_regex();
          this.$refs.error.temporary_regex();
        });
      },
      // 備考のエラーチェック
      remarks_check: function () {
        this.$refs.error.remarks_empty();
        this.$refs.error.remarks_max();
      },
      //保存メソッド
      edit: function () {
        if (this.project_name.length === 0) {
          alert("プロジェクト情報を設定してください。");
        } else if (this.editSubmit) return;
        else {
          this.loading = true;
          //フラグがfalseならば、フラグをtrueにしたうえでsubmit
          this.editSubmit = true;
          /*
           * **保存するのは、見出しに出している月（［表示］を押した月）。**
           *
           * 各行は「{表示した年}年{表示した月}月◯日」と出している。これまでは保存の
           * 日付を年月の選択欄から作っていたので、選択欄だけ変えて［保存］すると
           * 別の月へ保存し、その月の明細を消して入れ直していた。31日を選んだまま
           * 30日の月へ変えると "2026-09-31" を送り、サーバが10月1日と読んでいた。
           * 選択欄も表示中の月へ戻す（下の日付の組み立てと、保存後の読み直しが使う）。
           */
          this.year = String(this.selectYear);
          this.month = String(this.selectMonth);
          this.items = [];
          let n = 0;
          while (n < this.num1) {
            const day =
              this.day1[n].length === 1 ? "0" + this.day1[n] : this.day1[n];
            const formattedMonth =
              this.month.length === 1 ? "0" + this.month : this.month;
            //仮払入力は任意の為、replaceを行う分岐が必要
            let temporaryVal = this.temporary[n];
            if (!this.temporary[n]) {
              temporaryVal = 0;
            } else {
              temporaryVal = temporaryVal.replace(/,/g, "");
            }
            const item = {
              id: this.id[n],
              year: this.year,
              month: this.month,
              type: 1,
              project_id: this.project_id[n], 
              request_type: this.request_type[n],
              origin: this.origin[n],
              destination: this.destination[n],
              route: this.route[n],
              temporary: temporaryVal,
              cost: this.cost[n].replace(/,/g, ""),
              remarks: this.remarks[n],
              date: this.year + "-" + formattedMonth + "-" + day,
            };
            this.items.push(item);
            n++;
          }
          const params = new URLSearchParams();
          params.append("year", this.year);
          params.append("month", this.month);
          axios
            .post(process.env.VUE_APP_API_ORIGIN + "/updateExpense", this.items)
            .then(() => {
              this.$store.commit('set', ['sidebarBadgeRefreshTick', Date.now()]);
              alert(ConstList.REGISTER_MESSAGE);
              this.editSubmit = false;
              this.callList();
            })
            .catch((error) => {
              this.editSubmit = false;
              axios
              .post(`${process.env.VUE_APP_API_ORIGIN}/error/frontError`, { error: String(error) }, { headers: { 'Content-Type': 'application/json' } })
              .then(() => {
                /*
                 * **サーバが返した理由をそのまま出す。**
                 *
                 * 承認待ち・承認済みの月は保存できない。サーバは 409 で
                 * 「承認済みの経費精算は更新できません。」と理由を返している。
                 * それを「システムエラー」へ置き換えると、**利用者には
                 * なぜ保存できないのかが分からない。**
                 */
                const status = error && error.response ? Number(error.response.status) : 0;
                alert(backendErrorMessage(
                  error,
                  status ? ConstList.SYSTEM_ERROR : ConstList.SYSTEM_COMMUNICATION_ERROR
                ));
                // 状態のずれで断られたなら、画面を読み直して最新にする。
                if (status === 409) this.callList();
              })
              .catch(() => {
                alert(backendErrorMessage(error, ConstList.SYSTEM_COMMUNICATION_ERROR));
              });
            })
            .finally(() => {
              this.loading = false;
            })
        }
      },
      digitsOnly(field, index, e) {
        // 挿入系以外（削除/移動など）は許可
        if (!e.inputType || !e.inputType.startsWith('insert')) return;

        const t = e.target;
        const data  = e.data ?? ''; // 貼り付け時は複数文字
        const start = t.selectionStart ?? t.value.length;
        const end   = t.selectionEnd   ?? t.value.length;

        // 入力適用後の値を予測
        const next = t.value.slice(0, start) + data + t.value.slice(end);

        // 半角数字以外が混じるなら未然にブロック（全角かな/全角数字/記号/空白すべてNG）
        if (!/^\d*$/.test(next)) e.preventDefault();
      },

      sanitizeDigits(field, index) {
        // 念のための最終サニタイズ（ブラウザ差・貼り付け経路の取りこぼし対策）
        const arr = this[field];
        if (!Array.isArray(arr)) return;

        const cur = String(arr[index] ?? '');
        const cleaned = cur.replace(/[^\d]/g, ''); // 非数字を全削除（全角も消える）
        if (cur !== cleaned) arr.splice(index, 1, cleaned); // Vue2はspliceでリアクティブ維持
      },
      // 表示用のラベル変換
      getStatusLabel(status) {
        if (!status) {
          return ConstList.UNSUBMITTED; // '未申請'
        }
        return status;
      },
      // 承認状態の識別
      statusColor(status) {
        const label = this.getStatusLabel(status);
        switch (label) {
          case ConstList.REJECT:
          case ConstList.UNSUBMITTED:
            return { color: 'red' };
          case ConstList.APPROVAL_PENDING:
            return { color: 'orange' };
          case ConstList.APPROVAL:
            return { color: 'green' };
          default:
            return {};
        }
      },
      syncProjectName(i) {
        const id = this.project_id[i];
        const p = this.projectList.find(x => x.id === id);
        this.$set(this.project_name, i, p ? p.name : '');
      },
      fetchProjects() {
        axios.get(process.env.VUE_APP_API_ORIGIN + '/projects')
        .then(res => { this.projectList = res.data || []; })
        .catch(() => { this.projectList = []; });
      },
      // ひとつ前の行の値をコピー
      copyFromPrev(index) {
        if (index <= 0) return;
        const prev = index - 1;

        const fields = [
          'day1',
          'request_type',
          'origin',
          'destination',
          'route',
          'cost',
          'remarks',
          'temporary',
          'project_id',
          'project_name',
        ];

        fields.forEach(field => {
          const arr = this[field];
          if (!Array.isArray(arr)) return;
          this.$set(arr, index, arr[prev]);
        });
        // id はコピーしない（既存行ならそのまま、新規行なら undefined のまま）
        // コピーは欄から離れる操作を伴わないので、ここで見直さないと
        // **埋まった行のメッセージが残ったまま**になる。
        this.recheck();
      },
    },

    computed: {
      // ［保存］が押せない理由。承認待ち・承認済みは上に出している文と同じもの。
      saveBlockedReason: function () {
        const locked = submissionLockReason(this.statusBtn, this.errors);
        if (locked) return locked;
        return !this.statusBtn && this.activeButton ? '入力内容をご確認ください。表の上の注意事項を修正すると保存できます。' : '';
      },
      totalTransport: function () {
        const list = this.cost;
        const select = this.request_type;
        const sum = this.sum_transport;
        let result = 0;
        for (let i = 0; i < list.length; i++) {
          if (select[i] === ConstList.TRANSPORT_ID) {
            result = result + this.amountValue(list[i]);
          }
        }
        sum.splice(0, 1, result);
        return (
          "￥" + result.toString().replace(/([0-9]+?)(?=(?:[0-9]{3})+$)/g, "$1,")
        );
      },
      // 経費小計の計算
      totalExpense: function () {
        const list = this.cost;
        const select = this.request_type;
        const sum = this.sum_expense;
        let result = 0;
        for (let i = 0; i < list.length; i++) {
          if (select[i] === ConstList.EXPENSE_ID) {
            result = result + this.amountValue(list[i]);
          }
        }
        sum.splice(0, 1, result);
        return (
          "￥" + result.toString().replace(/([0-9]+?)(?=(?:[0-9]{3})+$)/g, "$1,")
        );
      },
      // 宿泊費合計の計算
      totalStay: function () {
        const list = this.cost;
        const select = this.request_type;
        const sum = this.sum_stay;
        let result = 0;
        for (let i = 0; i < list.length; i++) {
          if (select[i] === ConstList.STAY_ID) {
            result = result + this.amountValue(list[i]);
          }
        }
        sum.splice(0, 1, result);
        return (
          "￥" + result.toString().replace(/([0-9]+?)(?=(?:[0-9]{3})+$)/g, "$1,")
        );
      },
      // 経費合計の計算
      totalCost: function () {
        const list = this.cost;
        const sum = this.sum_cost;
        let result = 0;
        for (let i = 0; i < list.length; i++) {
          // 金額が入力されている場合処理を行う
          if (list[i]) {
            const data = list[i].replace(/,/g, "");
            if (data) {
              const cal = parseInt(data);
              result = result + cal;
            }
          }
        }
        sum.splice(0, 1, result);
        return (
          "￥" + result.toString().replace(/([0-9]+?)(?=(?:[0-9]{3})+$)/g, "$1,")
        );
      },
      // 仮払小計の計算
      totalTemporary: function () {
        const list = this.temporary;
        const sum = this.sum_temporary;
        let result = 0;
        for (let i = 0; i < list.length; i++) {
          // 仮払金額が入力されている場合処理を行う
          if (list[i]) {
            const data = list[i].replace(/,/g, "");
            if (data) {
              const cal = parseInt(data);
              result = result + cal;
            }
          }
        }
        sum.splice(0, 1, result);
        return (
          "￥" + result.toString().replace(/([0-9]+?)(?=(?:[0-9]{3})+$)/g, "$1,")
        );
      },
      // 差引戻・払額の計算
      sumPayment: function () {
        const cost = Number(this.sum_cost?.[0]) || 0;
        const temporary = Number(this.sum_temporary?.[0]) || 0;
        const sum = cost - temporary;
        const total = this.total;
        total.splice(0, 1, sum);
        return (
          "￥" + sum.toString().replace(/([0-9]+?)(?=(?:[0-9]{3})+$)/g, "$1,")
        );
      },
      // 入力欄を追加・削除出来るようにする(経費)
      lists1: function () {
        return Array.from(Array(this.num1).keys());
      },
      // 保存ボタンの活性非活性
      activeButton: function () {
        const list = this.num1;
        const year = this.year;
        const day1 = this.day1;
        const type = this.request_type;
        const cost = this.cost;
        const route = this.route;
        const remarks = this.remarks;
        const origin = this.origin;
        const destination = this.destination;
        // 行を全て削除した場合、非活性とする
        if (list === 0){
          return true;
        }
        for (let i = 0; i < list; i++) {
          if (!year || !day1[i] || !type[i] || !cost[i] || !remarks[i] || !route[i] || !this.project_id[i]) {
            // 全ての行から一つでも必須項目が入力されていない場合、非活性とする
            return true;
          }
          // 出張交通費だけ追加で必須
          if (type[i] === ConstList.TRANSPORT_ID) {
            // 出発と到着は両方必須
            if (!origin[i] || !destination[i]) {
              return true;
            }
          }

          // 文字数の上限を超えている行があれば保存させない。
          // これまでは「128文字以内で入力してください」と表示するだけで
          // 保存ボタンは押せた。サーバも受け取った値をそのままDBへ渡すため、
          // 上限を超えた値が保存できてしまい、列の狭い環境で初めて落ちていた。
          if (this.overMaxLength(origin[i], MAX_LENGTH.origin) ||
              this.overMaxLength(destination[i], MAX_LENGTH.destination) ||
              this.overMaxLength(route[i], MAX_LENGTH.route) ||
              this.overMaxLength(remarks[i], MAX_LENGTH.remarks)) {
            return true;
          }
        }

        // 全ての必須項目が入力されている場合、活性化する
        return false;
      },
    },

    mounted: function () {
      let today = moment();
      if (today.date() < 10) {
        today = today.subtract(1, 'months');
      }
      // ダッシュボードの「月次提出状況」の行から開いたときは、その行の月で開く
      // （URL に年月が付いてくる）。左メニューから開いたときは今までどおり。
      const asked = askedYearMonth(this.$route);
      this.year = asked ? String(asked.year) : today.format("YYYY");
      this.month = asked ? String(asked.month) : today.format("M");
      this.day1.splice(0, 1, "");
      this.request_type.splice(0, 1, "");
      this.origin.splice(0, 1, "");
      this.destination.splice(0, 1, "");
      this.route.splice(0, 1, "");
      this.cost.splice(0, 1, "");
      this.remarks.splice(0, 1, "");
      this.temporary.splice(0, 1, "");
      this.fetchProjects(); // プロジェクト一覧を先に確保
    },
  };
  </script>

  <style scoped>
  label,
  button {
    white-space: nowrap;
  }

  td {
    vertical-align: middle;
    white-space: nowrap;
    padding-top: 0;
    padding-bottom: 0;
  }

  .title {
    border: solid 1px gray;
  }

  .ruled-line {
    border-bottom: 1px solid #d8dbe0;
  }

  button:disabled {
    cursor: not-allowed;
  }

  .deleteBtn {
    height: 33px;
    margin-bottom: 18px;
    display: inline-block;
  }
  .asterisk {
    color: red;
  }

  .btn-add {
    margin-top: 20px;
  }

  .btn-register {
    margin-top: 20px;
  }
  </style>
